import {
  Gym, IDailyTimeTypes, IFlattenedTimeType, TimeSpan,
} from 'fitbeat.models';
import {
  AllowedBookingTimeFrames, Day, SpecificOperatingTimes, TimeType,
} from '../../helpers';
import { IPersistedGymConfig } from './IPersistedGymConfig';

export class GymInfoForTimeslots extends Gym {
  public specificOperatingTimes: SpecificOperatingTimes;

  public cancelledTimes: SpecificOperatingTimes;

  public overridenTimeSlotTypes?: Day[];

  public allowedBookingTimeFrames: AllowedBookingTimeFrames;

  constructor(
    initData: Gym & Partial<GymInfoForTimeslots> & IPersistedGymConfig,
  ) {
    super(initData);
    this.overridenTimeSlotTypes = initData.overridenTimeSlotTypes
      || this.mapOverridenTimeSlotTypes(initData.timeSlotTypes);
    this.specificOperatingTimes = initData.specificOperatingTimes
      || this.mapSpecificOperatingTimes(initData.specificTimeSlotTypes || []);
    this.cancelledTimes = initData.cancelledTimes || this.mapCancelledTimes(initData.cancelledDays || []);
    this.allowedBookingTimeFrames = initData.allowedBookingTimeFrames
      || new AllowedBookingTimeFrames(initData.overridenAllowedBookingTimeFrames);
  }

  private mapOverridenTimeSlotTypes(timeSlotTypes?: IDailyTimeTypes): Day[] | undefined {
    if (!timeSlotTypes) {
      return undefined;
    }

    function getDayTimeTypes(flattened: IFlattenedTimeType[]): TimeType[] {
      return flattened.map((flat: IFlattenedTimeType) => new TimeType(new TimeSpan(flat.start, flat.end), flat.type));
    }

    return [
      new Day(getDayTimeTypes(timeSlotTypes.Sunday)),
      new Day(getDayTimeTypes(timeSlotTypes.Monday)),
      new Day(getDayTimeTypes(timeSlotTypes.Tuesday)),
      new Day(getDayTimeTypes(timeSlotTypes.Wednesday)),
      new Day(getDayTimeTypes(timeSlotTypes.Thursday)),
      new Day(getDayTimeTypes(timeSlotTypes.Friday)),
      new Day(getDayTimeTypes(timeSlotTypes.Saturday)),
    ];
  }

  private mapSpecificOperatingTimes(
    specificTimeSlotTypes: IFlattenedTimeType[],
  ): SpecificOperatingTimes {
    const result = new SpecificOperatingTimes();
    // specific time slots first, to have precedence over public holidays
    for (const specific of specificTimeSlotTypes) {
      result.setTimeSlotForRange(specific.start, specific.end, this.timezone, specific.type);
    }
    result.setClosedOnDays(this.publicHolidays, this.timezone);
    return result;
  }

  private mapCancelledTimes(cancelledDays: string[]): SpecificOperatingTimes {
    const result = new SpecificOperatingTimes();
    result.setClosedOnDays(cancelledDays, this.timezone);
    return result;
  }
}
